export default __webpack_public_path__ + "static/media/workspace-intro-right.02d74a30.png";